import { SearchRequest } from '@/api/generated/model'

export const idmQueryKeys = {
  users: {
    current: () => ['users', 'current'],
    search: () => ['users', 'search'],
    searchRequest: (request?: SearchRequest) => [
      ...idmQueryKeys.users.search(),
      request
    ],
    searchAdmin: () => ['users', 'search', 'admin'],
    searchAdminRequest: (request?: SearchRequest) => [
      ...idmQueryKeys.users.searchAdmin(),
      request
    ]
  }
}
